const pb23DownloadsSearch = {
    init: () => {
        // console.log('pb23DownloadsList initialized!');
        $('.pb23-downloads--search').find('.jsToggleCategorieslMenu').on('click',function(){
            $(this).siblings('.submenu').toggleClass('show');
            return false;
        });
    }
}

window.loadedComponents.push({ component: 'pb23-downloads--search', init: pb23DownloadsSearch.init});

export default () => {
    pb23DownloadsSearch.init;
}